import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SelectedUserInfo } from "../../../@types/SelectedUserInfo";
import { UserRole } from "../../../@types/userRole";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const findSelectedUsers = createAsyncThunk(
  "massiveDocumentCreate/findSelectedUsers",
  async (usersCode : any, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const usersRole = state.massiveDocumentCreate.userRole;
      const { data } = await axiosInstance.get(`${api.baseURL}midtview`, {
        params: {
          where: {
            id: usersCode
          },
        },
      });

      const usersInfo = data.map((element: SelectedUserInfo) => {
        const uRole = usersRole.filter((uRole: UserRole) => uRole.code === element.id)
        // Agrega elementos que están en UserRole
        return {
          ...element,
          emailApiGS: uRole[0].user.email ? uRole[0].user.email : "",
        }
      })


      return usersInfo as SelectedUserInfo[];
    } catch (error:any) {
      const {message} = error
      rejectWithValue(message);
      throw message;
    }
  }
);
